import { ClockIcon, XMarkIcon } from "@heroicons/react/24/outline";

export default function DashboardAlerts({
  conflictMessage,
  isWaiting,
  onDismissConflict,
}) {
  if (!conflictMessage && !isWaiting) return null;

  return (
    <>
      {conflictMessage ? (
        <div
          role="alert"
          className="mb-3 flex items-start justify-between gap-3 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800"
        >
          <p>{conflictMessage}</p>
          <button
            type="button"
            className="shrink-0 rounded p-0.5 text-amber-700 hover:bg-amber-100"
            onClick={onDismissConflict}
            aria-label="Dismiss message"
          >
            <XMarkIcon className="h-4 w-4" />
          </button>
        </div>
      ) : null}
      {isWaiting ? (
        <div
          role="status"
          className="mb-3 flex items-center gap-2 rounded-lg border border-cyan-200 bg-cyan-50 px-3 py-2 text-sm text-cyan-800"
        >
          <ClockIcon className="h-4 w-4 animate-spin" />
          Waiting until this edition is no longer Not Published / Pending...
        </div>
      ) : null}
    </>
  );
}
